import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@fluentui/react-components";
import { Chat24Regular } from "@fluentui/react-icons";
import { useSageAccess } from "../access";
import { ATHENA_CHAT } from "../RequireProduct";
import styles from "./AthenaChatButton.module.css";

interface Props {
  disabled?: boolean;
}

/**
 * AthenaChatButton — header entry point to Athena chat, shown only when the
 * access lookup positively grants athena (fail closed, same rule as the
 * search entry). Icon-only: the Bonds header row is capped at the chat
 * column's 847px and carries the Athena pair plus Bonds' own buttons, so
 * both Athena entries are glyphs whose label survives as aria-label + title.
 */
export const AthenaChatButton: React.FC<Props> = ({ disabled = false }) => {
  const { status, hasAthena } = useSageAccess();

  if (status !== "ready" || !hasAthena) {
    return null;
  }

  return (
    <div className={styles.button}>
      <Link to={ATHENA_CHAT} className={styles.link} aria-disabled={disabled}>
        <Button disabled={disabled} className={styles.container} aria-label="Athena Chat" title="Athena Chat">
          <div className={styles.chatIcon}>
            <Chat24Regular color="#002664" />
          </div>
        </Button>
      </Link>
    </div>
  );
};
